<template>
  <div class="content-wrap">
  	<div class="content">
      <div class="header">
        <el-input 
          v-model="keyword_search" 
          placeholder="请输入手机号/昵称进行搜索" 
          class="search-input" 
          @input="handleSeacrInput"
          clearable
        ></el-input>
        <el-select v-model="member_uuid" placeholder="请选择VIP等级" clearable>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.member_name"
            :value="item.uuid">
          </el-option>
        </el-select>
        <el-button type="primary" class="search-btn" @click="handleSearchClick">搜索</el-button>
      </div>
      <div class="table-wrap">
      	<el-table
			    :data="tableData"
			    border
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      label="ID"
			      width="60"
			      align="center"
			      :index="handlerSerial"
			    >
			    </el-table-column>
			    <el-table-column
			      prop="user_name"
			      label="用户昵称"
			      width="100"
			      align="center"
			    >
			    </el-table-column>
			    <el-table-column
			      prop="account"
			      label="手机号"
			      align="center"
		      >
			    </el-table-column>
			    <el-table-column
			      label="头像"
			      width="120"
			      align="center"
		      >
		        <template slot-scope="scope">
              <div v-if="scope.row.user_icon">
		            <img :src="imgDomain + scope.row.user_icon" class="user_icon">
              </div>
              <img :src="imgDomain + 'FqqL2MeSJIgNiuaYF_cLHT2YUOGa'" class="user_icon" v-else>
		        </template>
			    </el-table-column>
			    <el-table-column
			      label="QQ"
			      align="center"
			      width="100"
          >
            <template slot-scope="scope">
            	 <span v-if="!scope.row.qq">-</span>
            	 <span v-else>{{scope.row.qq}}</span>
            </template>
			    </el-table-column>
			    <el-table-column
			      prop="create_time"
			      label="注册时间"
			      align="center"
          >
			    </el-table-column>
          <el-table-column
			      label="VIP等级"
			      align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.member_card_name">{{scope.row.member_card_name}}</span>
              <span v-else>无</span>
            </template>
			    </el-table-column>
			    <el-table-column
			      label="操作"
			      align="center"
		      >
		        <template slot-scope="scope">
		          <span class="color-text detail-text" @click="toDetailClick(scope.row)" v-if="have_detail_auth">查看详情</span>
		        </template>
			    </el-table-column>
			  </el-table>
			  <common-pagination
			  :total="total"
        :page_size="page_size"
        :page_index="page_index"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			  ></common-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { userList } from '@/api/user';
import { qiniuInfo } from '@/api/common';
import { mapState } from 'vuex';
import CommonPagination from '@/components/CommonPagination';
import { getMemberList } from '@/api/member-setting';

export default {
  name: 'userlist',
  data() {
  	return {
  		keyword_search: '',
  		tableData: [],
  		page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
      three_rules: [],
      have_detail_auth: false, //是否具有查看详情权限
      options: [],
      member_uuid: ''
  	}
  },
  components: {
    CommonPagination,
  },
  mounted() {
    this.getUserList();
    this.getQiniuInfo();
    this.handleThreeRules();
    this._getMemberList();
  },
  computed: {
    ...mapState(['imgDomain', 'operationList']),
  },
  methods: {
    async _getMemberList() {
      const { status, data } = await getMemberList();
      if (status === 200 ) {
        this.options = data;
      }
    },
  	async getUserList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size,
        keyword_search: this.keyword_search,
        member_uuid: this.member_uuid
    	}
       const { data, status } = await userList(postData);
       if (status !== 200) return
       console.log(data, '用户数据')
       this.tableData = data.data;
       this.total = data.total;
  	},
  	handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    async getQiniuInfo() {
      const data = await qiniuInfo();
      console.log(data, '七牛')
    },
    handelPagesizeChange(size) {
    	this.page_size = size;
    	this.getUserList();
    },
    handlePageChange(page) {
    	this.page_index = page;
    	this.getUserList();
    },
    handleSearchClick() {
      this.page_index = 1;
    	this.getUserList();
    },
    handleSeacrInput(val) {
    	//当inputValu为空时重新请求数据
    	if (!val) this.handleSearchClick()
    },
    toDetailClick(row) {
    	this.$router.push({
    		path: '/user-list/user-detail',
    		query: {
    			id: row.uuid
    		}
    	})
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      if (this.three_rules.length) {
        this.have_detail_auth = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.content {
  .header {
    display: flex;
    align-items: center;
  }
	.search-input {
    width: 300px;
    margin-right: 20px;
	}
	.search-btn {
		margin-left: 20px;
	}
	.table-wrap {
    margin-top: 20px;
    .user_icon {
      height:  100px;
    }
	}
	.color-text {
		color: @color-text;
	}
	.detail-text {
		cursor: pointer;
  }
}
/deep/.el-table__row {
  height: 100px;
}
</style>
